/* eslint-disable import/no-cycle */
import { takeLatest, put, all } from 'redux-saga/effects'
import { Types } from '../ducks/technicalDep'
import { graphClient } from './auth'
import { history } from '../index'
import powerAppsApi from '../../services/powerapps/index'
import { notifyError } from '../../utils/notify'
import oikosApi from '../../services/oikos'
import endPoints1Api from '../../services/end_points_1'
import qs from 'qs'
import { getProdutoFinalDoc, PROD_COORDENADOR_PF_FIELDS, oikosGet } from '../../utils/fc'

function* listProjects(action = {}) {
  const user = action.payload;
  console.log('listProjects user', user)
  try {
    let filteredData = [];
    const res = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'proj',
      order_field: 'proj_dtCria',
		  order_dir: 'DESC',
      data: {
        proj_ativo: 1,
      },
      fields: {
        '(SELECT pj_nomefanta FROM pj WHERE pj.pj_id = (SELECT contrato_contratante FROM contrato WHERE contrato.contrato_id = proj.contrato_id))': 'pj_nomefanta',
        '(SELECT areaAtua_id FROM pj WHERE pj.pj_id = (SELECT contrato_contratante FROM contrato WHERE contrato.contrato_id = proj.contrato_id))': 'areaAtua_id',
        '(SELECT contrato_num FROM contrato WHERE contrato.contrato_id = proj.contrato_id)': 'contrato_num',
        '(SELECT contrato_contratante FROM contrato WHERE contrato.contrato_id = proj.contrato_id)': 'contrato_contratante',
        '(SELECT minuta_id FROM contrato WHERE contrato.contrato_id = proj.contrato_id)': 'minuta_id',
        '(SELECT contrato_dtAssin FROM contrato WHERE contrato.contrato_id = proj.contrato_id)': 'contrato_dtAssin',
        '(SELECT contrato_prazoVigencia FROM contrato WHERE contrato.contrato_id = proj.contrato_id)': 'contrato_prazoVigencia',
        '(SELECT contrato_prazoVigencia FROM contrato WHERE contrato.contrato_original = proj.contrato_id ORDER BY contrato_dtCria DESC LIMIT 1)': 'contrato_prazoVigenciaAditivo',
        '(SELECT contrato_obj FROM contrato WHERE contrato.contrato_id = proj.contrato_id)': 'contrato_obj',
        '(SELECT COALESCE ((SELECT SUM(contrato_vlrGlobal) FROM contrato WHERE contrato.contrato_original = proj.contrato_id), 0) + (SELECT contrato_vlrGlobal FROM contrato WHERE contrato.contrato_id = proj.contrato_id))': 'contrato_vlrGlobal',
        '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe AS pe WHERE pe.proj_id = proj.proj_id AND pe.projAtuacao_id = 8 AND pe.projEquipe_ativo = 1 AND (pe.projEquipe_fim IS NULL OR pe.projEquipe_fim > NOW()) ORDER BY pe.projEquipe_ini DESC LIMIT 1))': 'proj_responsavelNome',
        '(SELECT segi FROM contrato WHERE contrato.contrato_id = proj.contrato_id)': 'segi',
        '(SELECT COUNT(*) FROM prod WHERE prod.proj_id = proj.proj_id AND prod.prod_ativo = 1)': 'total_produtos',
        '(SELECT COUNT(*) FROM prod WHERE prod.proj_id = proj.proj_id AND prod.prod_ativo = 1 AND (SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1) = 7 AND (SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 AND psa.prodStatusTp_id = 7 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1) IS NOT NULL)': 'total_produtos_aprovados',
        '(SELECT COUNT(*) FROM rec WHERE rec.orcRubr_id = proj.orcRubr_id AND rec.rec_ativo = 1)': 'total_eventos',
        '(SELECT COUNT(*) FROM rec WHERE rec.orcRubr_id = proj.orcRubr_id AND rec.rec_ativo = 1 AND rec.rec_risco = 0)': 'total_eventos_pagos',
        '(SELECT COUNT(*) FROM contrForn cf WHERE cf.orcItem_id IN (SELECT oi.orcItem_id FROM orcItem oi WHERE oi.orcRubr_id IN (SELECT vt.id_oikos FROM viewOrcRubr_taxonomia2 vt WHERE vt.nivel3_id = proj.orcRubr_id)) AND cf.contrForn_ativo = 1)': 'total_forn_contratos',
        '(SELECT COUNT(*) FROM contrFornEvento cfe INNER JOIN contrForn cf ON cf.contrForn_id = cfe.contrForn_id WHERE cf.orcItem_id IN (SELECT oi.orcItem_id FROM orcItem oi WHERE oi.orcRubr_id IN (SELECT vt.id_oikos FROM viewOrcRubr_taxonomia2 vt WHERE vt.nivel3_id = proj.orcRubr_id)) AND cf.contrForn_ativo = 1 AND cfe.contrFornEvento_ativo = 1)': 'total_forn_eventos',
        '(SELECT COUNT(*) FROM contrFornEvento cfe INNER JOIN contrForn cf ON cf.contrForn_id = cfe.contrForn_id WHERE cf.orcItem_id IN (SELECT oi.orcItem_id FROM orcItem oi WHERE oi.orcRubr_id IN (SELECT vt.id_oikos FROM viewOrcRubr_taxonomia2 vt WHERE vt.nivel3_id = proj.orcRubr_id)) AND cf.contrForn_ativo = 1 AND cfe.contrFornEvento_ativo = 1 AND (SELECT bdro.bdro_dtQuit FROM bdro WHERE bdro.bdro_tabRef = "contrFornEvento" AND bdro.bdro_tabId = cfe.contrFornEvento_id AND bdro.bdro_ativo = 1 ORDER BY bdro.bdro_id DESC LIMIT 1) IS NOT NULL)': 'total_forn_eventos_pagos',
        '(SELECT COUNT(*) FROM formularioDado fd INNER JOIN formulario f ON f.formulario_id = fd.formulario_id WHERE fd.perguntaFormulario_id = 18 AND fd.formularioDado_resposta = proj.proj_id AND f.formulario_ativo = 1 AND f.tpFormulario_id = 1)': 'tem_pesquisa',
        ...(user.pf_id && {[`(SELECT projEquipe_id FROM projEquipe WHERE projEquipe.proj_id = proj.proj_id AND projEquipe.pf_id = ${user.pf_id} AND projEquipe.projEquipe_ativo = 1 ORDER BY projEquipe_dtCria DESC LIMIT 1)`] : 'projEquipe_id'})
      },
    })}`)

    if (user.perm_id > 3 || user.perm_id === null) {
      filteredData = res.data.filter((proj) => proj.projEquipe_id)
    }

    console.log('lista projetos do oikos res', res.data)

    yield put({
      type: Types.LIST_PROJECTS_SUCCEEDED,
      payload: (user.perm_id > 3 || user.perm_id === null) ? filteredData : res.data,
    })
  } catch (err) {
    console.log(err)
    notifyError('Não foi possível listar os projetos do oikos.')
    yield put({
      type: Types.LIST_PROJECTS_FAILED,
    })
  }
}

function* listOpProjects() {
  try {

    /*
    const res = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'contrato',
      data: {
        contrato_ativo: 1,
        contrato_cadastro: '1',
        contrato_projAbert: 0,

      },
      fields: {
        '(SELECT pj_nomefanta FROM pj WHERE pj.pj_id = contrato.contrato_contratante)': 'pj_nomefanta',
        '(SELECT proj_nome FROM proj WHERE proj.contrato_id = contrato.contrato_original)': 'proj_nome',
      },
    })}`)
    */

    const res = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'proj',
      data: {
        proj_ativo: 1,
      },
      fields: {
        '(SELECT pj_nomefanta FROM pj WHERE pj.pj_id = (SELECT contrato_contratante FROM contrato WHERE contrato.contrato_id = proj.contrato_id))': 'pj_nomefanta',
        '(SELECT contrato_vlrGlobal FROM contrato WHERE contrato.contrato_id = proj.contrato_id)': 'contrato_vlrGlobal',
        '(SELECT contratoInst_id FROM contrato WHERE contrato.contrato_id = proj.contrato_id)': 'contratoInst_id',
        '(SELECT contrato_aguardarOS FROM contrato WHERE contrato.contrato_id = proj.contrato_id)': 'contrato_aguardarOS'
      },
    })}`)

    const updatedListOpProjects = res.data.filter((proj) => proj.projSituacao_id < 2)

    const filteredProj = updatedListOpProjects
    .filter((proj) => !!proj.contrato_id)
    .map((proj) => {
      const projCheckObj = JSON.parse(proj.proj_check);
      return {...proj, proj_check: projCheckObj}
    })


    console.log('lista projetos em abertura do oikos res', filteredProj)

    yield put({
      type: Types.LIST_OPPROJECTS_SUCCEEDED,
      payload: filteredProj,
    })
  } catch (err) {
    console.log(err)
    notifyError('Não foi possível listar os projetos do oikos.')
    yield put({
      type: Types.LIST_OPPROJECTS_FAILED,
    })
  }
}

function* getProject(action) {
  try {
    const projectId = action.payload
    const queryVigenciaAditivo = `
      (SELECT sub.contrato_prazoVigencia
       FROM contrato AS sub
       WHERE sub.contrato_ativo = 1
       AND sub.contrato_prazoVigencia IS NOT NULL
       AND (
           sub.contrato_id = (
               SELECT COALESCE(c.contrato_original, c.contrato_id)
               FROM contrato c
               WHERE c.contrato_id = proj.contrato_id
           )
           OR
           sub.contrato_original = (
               SELECT COALESCE(c.contrato_original, c.contrato_id)
               FROM contrato c
               WHERE c.contrato_id = proj.contrato_id
           )
       )
       ORDER BY sub.contrato_prazoVigencia DESC
       LIMIT 1)
    `.replace(/\s+/g, ' ').trim();

    const res = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'proj',
      data: {
        proj_id: projectId,
        proj_ativo: 1,
      },
      fields: {
        '(SELECT pj_nomeFanta FROM pj WHERE pj.pj_id = (SELECT contrato_contratante FROM contrato WHERE contrato.contrato_id = proj.contrato_id))': 'pj_nomeFanta',
        '(SELECT pj_emailPrin FROM pj WHERE pj.pj_id = (SELECT contrato_contratante FROM contrato WHERE contrato.contrato_id = proj.contrato_id))': 'pj_emailPrin',
        '(SELECT contrato_num FROM contrato WHERE contrato.contrato_id = proj.contrato_id)': 'contrato_num',
        '(SELECT contrato_dtAssin FROM contrato WHERE contrato.contrato_id = proj.contrato_id)': 'contrato_dtAssin',
        '(SELECT contrato_prazoVigencia FROM contrato WHERE contrato.contrato_id = proj.contrato_id)': 'contrato_prazoVigencia',
        [queryVigenciaAditivo]: 'contrato_prazoVigenciaAditivo',
        '(SELECT contrato_obj FROM contrato WHERE contrato.contrato_id = proj.contrato_id)': 'contrato_obj',
        '(SELECT contrato_obs FROM contrato WHERE contrato.contrato_id = proj.contrato_id)': 'contrato_obs',
        '(SELECT contrato_contratante FROM contrato WHERE contrato.contrato_id = proj.contrato_id)': 'contrato_contratante',
        '(SELECT contrato_vlrGlobal FROM contrato WHERE contrato.contrato_id = proj.contrato_id)': 'contrato_vlrGlobal',
        '(SELECT segi FROM contrato WHERE contrato.contrato_id = proj.contrato_id)': 'segi',
        '(SELECT pf_id FROM projEquipe AS pe WHERE pe.proj_id = proj.proj_id AND pe.projAtuacao_id = 8 AND pe.projEquipe_ativo = 1 AND pe.projEquipe_fim IS NULL ORDER BY pe.projEquipe_ini DESC LIMIT 1)': 'proj_coord', 
      },
    })}`)

    const propOrcItems = yield powerAppsApi.post('/',
      {
        acao: 'get_proporcitems_proj',
        proj_id: projectId,
      },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      }
    )

    const orcItems = yield endPoints1Api.post('/',
      {
        acao: 'get_orcItems_proj',
        proj_id: projectId,
      },
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Accept: 'multipart/form-data',
        },
      }
    )

    if (res.data[0] && orcItems.data) {
      console.log('exibindo dados do projeto no oikosa res', {...res.data[0], orcItems: orcItems.data, propOrcItems: propOrcItems.data})

      res.data[0].proj_check = JSON.parse(res.data[0].proj_check)
      yield put({
        type: Types.GET_PROJECT_SUCCEEDED,
        payload: {...res.data[0], orcItems: orcItems.data, propOrcItems: propOrcItems.data},
      });
    } else {
      notifyError('Projeto não encontrado no Oikos.')
      history.push('/')
      yield put({
        type: Types.GET_PROJECT_FAILED,
      })
    }
  } catch (err) {
    console.tron.log('Não foi possível carregar o projeto.', err)
    notifyError('Não foi possível carregar o projeto.')
    yield put({
      type: Types.GET_PROJECT_FAILED,
    })
  }
}

function* getProducts() {
  try {
    const endpoint = '/sites/ecossissolucoes.sharepoint.com:/projetos:/lists/9f87ed00-e9e6-45e7-8296-37a76af3f332/items?top=10000&expand=fields'

    const res = yield graphClient.api(endpoint).get()

    console.tron.log('getProducts sharepoint res', res)

    yield put({
      type: Types.GET_PRODUCTS_SUCCEEDED,
      payload: res.value,
    })
  } catch (err) {
    console.tron.log(err)
    notifyError('Não foi possível carregar os produtos.')
    yield put({
      type: Types.GET_PRODUCTS_FAILED,
    })
  }
}

function* getProductsFromOikos(action)  {
  try {
    const produtos = yield oikosGet({
      action: 'get',
      table: 'prod',
      data: {
        prod_ativo: 1,
      },
      fields: {
        "(SELECT pfCoord.pf_emailProf FROM prodStatusAlt psa, projEquipe pe, pf pfCoord WHERE psa.prod_id = prod.prod_id AND pe.proj_id = prod.proj_id AND pfCoord.pf_id = pe.pf_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_id = (SELECT psa2.prodStatusAlt_id FROM prodStatusAlt psa2 WHERE psa2.prod_id = prod.prod_id AND psa2.prodStatusTp_id = 6 ORDER BY psa2.prodStatusAlt_data DESC, psa2.prodStatusAlt_id DESC LIMIT 1) AND pe.projAtuacao_id = 8 AND psa.prodStatusAlt_data >= pe.projEquipe_ini AND (pe.projEquipe_fim IS NULL OR psa.prodStatusAlt_data <= pe.projEquipe_fim) LIMIT 1)":
    "prod_responsavel_email",

  "(SELECT pfCoord.pf_nomeExibicao FROM prodStatusAlt psa, projEquipe pe, pf pfCoord WHERE psa.prod_id = prod.prod_id AND pe.proj_id = prod.proj_id AND pfCoord.pf_id = pe.pf_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_id = (SELECT psa2.prodStatusAlt_id FROM prodStatusAlt psa2 WHERE psa2.prod_id = prod.prod_id AND psa2.prodStatusTp_id = 6 ORDER BY psa2.prodStatusAlt_data DESC, psa2.prodStatusAlt_id DESC LIMIT 1) AND pe.projAtuacao_id = 8 AND psa.prodStatusAlt_data >= pe.projEquipe_ini AND (pe.projEquipe_fim IS NULL OR psa.prodStatusAlt_data <= pe.projEquipe_fim) LIMIT 1)":
    "prod_responsavelNome",
    '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 AND projEquipe.projEquipe_fim IS NULL ORDER BY projEquipe_dtCria DESC LIMIT 1))' : 'prod_responsavelNomeAtual',
    '(SELECT pf_emailProf FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 AND projEquipe.projEquipe_fim IS NULL ORDER BY projEquipe_dtCria DESC LIMIT 1))' : 'prod_responsavel_email_atual',
        ...PROD_COORDENADOR_PF_FIELDS,
        "(SELECT prodStatusTp_nome FROM prodStatusTp WHERE prodStatusTp.prodStatusTp_id = prod.prodStatusTp_id)":
          "prodStatusTp_nome",
        "(SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)":
          "prodStatusActual_id",
        "(SELECT proj.projSituacao_id FROM proj WHERE proj.proj_id = prod.proj_id)":
          "projSituacao_id",
        "(SELECT proj.proj_nome FROM proj WHERE proj.proj_id = prod.proj_id)":
          "proj_nome",
        "(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 AND psa.prodStatusTp_id = 6 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)":
          "prodEntregueAoClienteData",
        "(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 AND psa.prodStatusTp_id = 7 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)":
          "prodAprovacaoData",
      },
    })

  const produtosEmAndamento = (produtos.data).filter((produto) => produto.projSituacao_id === 2);
  /*
  const updatedProducts = yield all(products.map( function* (product) {
    const docAndAnexos = yield getProdutoFinalDoc(product.prod_drive, 'admin@ecossis.com.br')
    const prodDocUrl = docAndAnexos.getProdutoFinalDoc;
    const anexosUrl = docAndAnexos.getAnexosFolder;
    let aprovCliente = 0;
    if (product.prodStatusPenultimo_id === 6 && product.prodStatusActual_id === 9) {
      aprovCliente = 1;
    }
    const updatedProduct = {...product, prodDocUrl: `${prodDocUrl.value[0].webUrl}`, anexosUrl: `${anexosUrl.value[0].webUrl}`, aprovCliente: aprovCliente }
    console.log(updatedProduct)
    return updatedProduct;
  }))
  */


    console.log('getProductsFromOikos res', produtosEmAndamento)

    yield put({
      type: Types.GET_PRODUCTS_FROM_OIKOS_SUCCEEDED,
      payload: produtosEmAndamento,
    })
  } catch (err) {
    console.tron.log(err)
    console.log(err)
    notifyError('Não foi possível carregar os produtos.')
    yield put({
      type: Types.GET_PRODUCTS_FROM_OIKOS_FAILED,
    })
  }
}

function* getProjectProducts(action) {
  try {
    const projectId = action.payload
    const res = yield oikosGet({
      action: 'get',
      table: 'prod',
      data: {
        proj_id: projectId,
        prod_ativo: 1,
      },
      fields: {
        "(SELECT pfCoord.pf_emailProf FROM prodStatusAlt psa, projEquipe pe, pf pfCoord WHERE psa.prod_id = prod.prod_id AND pe.proj_id = prod.proj_id AND pfCoord.pf_id = pe.pf_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_id = (SELECT psa2.prodStatusAlt_id FROM prodStatusAlt psa2 WHERE psa2.prod_id = prod.prod_id AND psa2.prodStatusTp_id = 6 ORDER BY psa2.prodStatusAlt_data DESC, psa2.prodStatusAlt_id DESC LIMIT 1) AND pe.projAtuacao_id = 8 AND psa.prodStatusAlt_data >= pe.projEquipe_ini AND (pe.projEquipe_fim IS NULL OR psa.prodStatusAlt_data <= pe.projEquipe_fim) LIMIT 1)":
    "prod_responsavel_email",

  "(SELECT pfCoord.pf_nomeExibicao FROM prodStatusAlt psa, projEquipe pe, pf pfCoord WHERE psa.prod_id = prod.prod_id AND pe.proj_id = prod.proj_id AND pfCoord.pf_id = pe.pf_id AND psa.prodStatusTp_id = 6 AND psa.prodStatusAlt_id = (SELECT psa2.prodStatusAlt_id FROM prodStatusAlt psa2 WHERE psa2.prod_id = prod.prod_id AND psa2.prodStatusTp_id = 6 ORDER BY psa2.prodStatusAlt_data DESC, psa2.prodStatusAlt_id DESC LIMIT 1) AND pe.projAtuacao_id = 8 AND psa.prodStatusAlt_data >= pe.projEquipe_ini AND (pe.projEquipe_fim IS NULL OR psa.prodStatusAlt_data <= pe.projEquipe_fim) LIMIT 1)":
    "prod_responsavelNome",
    '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 AND projEquipe.projEquipe_fim IS NULL ORDER BY projEquipe_dtCria DESC LIMIT 1))' : 'prod_responsavelNomeAtual',
    '(SELECT pf_emailProf FROM pf WHERE pf.pf_id = (SELECT pf_id FROM projEquipe WHERE projEquipe.proj_id = prod.proj_id AND projEquipe.projAtuacao_id = 8 AND projEquipe.projEquipe_ativo = 1 AND projEquipe.projEquipe_fim IS NULL ORDER BY projEquipe_dtCria DESC LIMIT 1))' : 'prod_responsavel_email_atual',
        ...PROD_COORDENADOR_PF_FIELDS,
        //'(SELECT prodStatusTp_nome FROM prodStatusTp WHERE prodStatusTp.prodStatusTp_id = prod.prodStatusTp_id)': 'prodStatusTp_nome',
        '(SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)': 'prodStatusActual_id',
        '(SELECT psa.prodStatusAlt_obs FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)': 'prodStatusAlt_obs',
        '(SELECT psa.prodStatusAlt_data FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1)': 'prodStatusAlt_data',
        '(SELECT psa.prodStatusTp_id FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 ORDER BY prodStatusAlt_dtCria DESC LIMIT 1 OFFSET 1)': 'prodStatusPenultimo_id',
        '(SELECT COUNT(*) FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 AND psa.prodStatusTp_id = 6)': 'hasStatus6',
        '(SELECT COUNT(*) FROM prodStatusAlt psa WHERE psa.prod_id = prod.prod_id AND psa.prodStatusAlt_ativo = 1 AND psa.prodStatusTp_id = 5)': 'hasStatus5',
      }
    })

  const products = res.data;
  /*
  const updatedProducts = yield all(products.map( function* (product) {
    const docAndAnexos = yield getProdutoFinalDoc(product.prod_drive, 'admin@ecossis.com.br')
    const prodDocUrl = docAndAnexos.getProdutoFinalDoc;
    const anexosUrl = docAndAnexos.getAnexosFolder;
    let aprovCliente = 0;
    if (product.prodStatusPenultimo_id === 6 && product.prodStatusActual_id === 9) {
      aprovCliente = 1;
    }
    const updatedProduct = {...product, prodDocUrl: `${prodDocUrl.value[0].webUrl}`, anexosUrl: `${anexosUrl.value[0].webUrl}`, aprovCliente: aprovCliente }
    console.log(updatedProduct)
    return updatedProduct;
  }))
  */


    console.log('getProjectProducts res', res.data)

    yield put({
      type: Types.GET_PROJECT_PRODUCTS_SUCCEEDED,
      payload: products,
    })
  } catch (err) {
    console.tron.log(err)
    console.log(err)
    notifyError('Não foi possível carregar os produtos.')
    yield put({
      type: Types.GET_PROJECT_PRODUCTS_FAILED,
    })
  }
}

function* getProductFiles(action) {
  try {
    const productId = action.payload
    const in_txt = "!IN!(SELECT documento_id FROM documentoVinc WHERE documentoVinc_tabRef = 'prod' AND documentoVinc_tabId = " + productId + ")"
    const res = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'arquivo',
      data: {
        arquivo_ativo: 1,
        arquivo_tabRef: 'documento',
        arquivo_tabId: in_txt,
      },
    })}`)

    console.log('getProductFiles res', res.data)

    yield put({
      type: Types.GET_PRODUCT_FILES_SUCCEEDED,
      payload: res.data,
    })
  } catch (err) {
    console.log(err)
    notifyError('Não foi possível carregar os arquivos.')
    yield put({
      type: Types.GET_PRODUCT_FILES_FAILED,
    })
  }
}

function* getTeam() {
  try {
    const res = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'pf',
      data: {
        pf_ativo: 1,
        dpto_id: 4,
      },
    })}`)

    console.log('listar_equipe', res.data)

    yield put({
      type: Types.GET_TEAM_SUCCEEDED,
      payload: res.data || [],
    })
  } catch (err) {
    console.log(err)
    yield put({
      type: Types.GET_TEAM_FAILED,
    })
  }
}

function* getProjectTeam(action) {
  try {
    const projectId = action.payload
    const res = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'projEquipe',
      data: {
        proj_id: projectId,
        projEquipe_ativo: 1,
      },
      fields: {
          '(SELECT pf_emailProf FROM pf WHERE pf.pf_id = projEquipe.pf_id)': 'email',
          'pf_id': 'id',
          '(SELECT pf_nomeExibicao FROM pf WHERE pf.pf_id = projEquipe.pf_id)': 'nome',
      },
    })}`)

    console.log('listar_equipe_projeto projEquipe', res.data)

    yield put({
      type: Types.GET_PROJECT_TEAM_SUCCEEDED,
      payload: res.data.filter(projEquipe => projEquipe.pf_id) || [],
    })
  } catch (err) {
    console.tron.log(err)
    yield put({
      type: Types.GET_PROJECT_TEAM_FAILED,
    })
  }
}

function* getProjectContract(action) {
  try {
    const contractId = action.payload
    const res = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'contrato',
      data: {
        contrato_id: contractId,
        contrato_ativo: 1,
      }
    })}`)

    console.log('exibindo dados do contrato do projeto no oikos res', res.data[0])

    if (res.data[0]) {
      yield put({
        type: Types.GET_PROJECT_CONTRACT_SUCCEEDED,
        payload: res.data[0],
      })
    } else {
      notifyError('contrato do projeto não encontrado no Oikos.')
      history.push('/')
      yield put({
        type: Types.GET_PROJECT_CONTRACT_FAILED,
      })
    }
  } catch (err) {
    console.tron.log('Não foi possível carregar o contrato do projeto.', err)
    notifyError('Não foi possível carregar o contrato do projeto.')
    yield put({
      type: Types.GET_PROJECT_CONTRACT_FAILED,
    })
  }
}

function* getAtivTp() {
  try {
    const res = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'prodAtivTp',

    })}`)

    console.log('listar_atividadesTp', res.data)

    yield put({
      type: Types.GET_ATIVTP_SUCCEEDED,
      payload: res.data || [],
    })
  } catch (err) {
    console.log(err)
    yield put({
      type: Types.GET_ATIVTP_FAILED,
    })
  }
}
function* getAval() {
  try {
    const res = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'aval',

    })}`)

    console.log('listar_aval', res.data)

    yield put({
      type: Types.GET_AVAL_SUCCEEDED,
      payload: res.data || [],
    })
  } catch (err) {
    console.log(err)
    yield put({
      type: Types.GET_AVAL_FAILED,
    })
  }
}
function* getAprov() {
  try {
    const res = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'aprov',

    })}`)

    console.log('listar_aprov', res.data)

    yield put({
      type: Types.GET_APROV_SUCCEEDED,
      payload: res.data || [],
    })
  } catch (err) {
    console.log(err)
    yield put({
      type: Types.GET_APROV_FAILED,
    })
  }
}

function* getAtivProducts(action) {
  try {
    const prodId = action.payload
    const res = yield oikosApi.get(`/?${qs.stringify({
      action: 'get',
      table: 'prodAtiv',
      data: {
        prod_id: prodId,
        prodAtiv_ativo: 1,
      },
    })}`)

    console.log('getAtivProducts res', res.data)
    console.log('prodId = ', prodId)

    yield put({
      type: Types.GET_ATIV_PRODUCTS_SUCCEEDED,
      payload: res.data,
    })
  } catch (err) {
    console.tron.log(err)
    notifyError('Não foi possível carregar as atividades.')
    yield put({
      type: Types.GET_ATIV_PRODUCTS_FAILED,
    })
  }
}

export const technicalDepSagas = [
  takeLatest(Types.LIST_PROJECTS_REQUESTED, listProjects),
  takeLatest(Types.LIST_OPPROJECTS_REQUESTED, listOpProjects),
  takeLatest(Types.GET_PROJECT_REQUESTED, getProject),
  takeLatest(Types.GET_PRODUCTS_REQUESTED, getProducts),
  takeLatest(Types.GET_PROJECT_PRODUCTS_REQUESTED, getProjectProducts),
  takeLatest(Types.GET_PRODUCT_FILES_REQUESTED, getProductFiles),
  takeLatest(Types.GET_TEAM_REQUESTED, getTeam),
  takeLatest(Types.GET_PROJECT_TEAM_REQUESTED, getProjectTeam),
  takeLatest(Types.GET_PROJECT_CONTRACT_REQUESTED, getProjectContract),
  takeLatest(Types.GET_ATIVTP_REQUESTED, getAtivTp),
  takeLatest(Types.GET_ATIV_PRODUCTS_REQUESTED, getAtivProducts),
  takeLatest(Types.GET_AVAL_REQUESTED, getAval),
  takeLatest(Types.GET_APROV_REQUESTED, getAprov),
  takeLatest(Types.GET_PRODUCTS_FROM_OIKOS_REQUESTED, getProductsFromOikos),
]
